import React from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import AccessibleDialog from "./AccessibleDialog";

export default function ConfirmActionDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "ยืนยัน",
  cancelLabel = "ยกเลิก",
  tone = "danger",
  isBusy = false,
  isDarkMode = false,
}) {
  if (!open) return null;
  const danger = tone === "danger";

  return (
    <AccessibleDialog onClose={isBusy ? undefined : onClose} label={title} closeOnBackdrop={!isBusy}>
      <div className={`w-full max-w-md rounded-2xl border p-6 shadow-2xl ${isDarkMode ? "border-slate-700 bg-[#1E1F20] text-white" : "border-stone-200 bg-white text-slate-950"}`}>
        <div className={`mb-4 flex h-11 w-11 items-center justify-center rounded-full ${danger ? "bg-rose-500/10 text-rose-600" : "bg-amber-500/10 text-amber-700"}`}>
          <AlertTriangle size={22} aria-hidden="true" />
        </div>
        <h2 className="text-xl font-black">{title}</h2>
        <p className="mt-2 text-sm font-medium leading-6 opacity-70">{description}</p>
        <div className="mt-6 flex gap-3">
          <button type="button" disabled={isBusy} onClick={onClose} className="min-h-11 flex-1 rounded-xl border border-current/15 px-4 text-sm font-bold disabled:opacity-50">
            {cancelLabel}
          </button>
          <button type="button" disabled={isBusy} onClick={onConfirm} className={`min-h-11 flex-1 rounded-xl px-4 text-sm font-black text-white disabled:opacity-50 ${danger ? "bg-rose-600 hover:bg-rose-700" : "bg-emerald-700 hover:bg-emerald-800"}`}>
            {isBusy ? <span className="inline-flex items-center gap-2"><Loader2 size={16} className="animate-spin" />กำลังดำเนินการ</span> : confirmLabel}
          </button>
        </div>
      </div>
    </AccessibleDialog>
  );
}
